export default [
    {
        path: '/rest/annotations',
        name: 'legacy.annotations',
    },
    {
        path: '/?_f=annotations',
        name: 'legacy.annotation.delete',
    },
    {
        path: '/?_f=annotations&action=addAnnotation',
        name: 'legacy.annotation.reply',
    },
    {
        path: '/rest/annotation/:id',
        name: 'legacy.annotation.updated',
    },
]